import PlaceholderImage from "src/components/nodata/PlaceholderImage";
import { classNames } from "src/helpers/classNames";

export default function PartnersSection({ data }) {
  return (
    <section className={classNames(data?.hidden ? "hidden" : "relative mx-auto max-w-7xl px-6 py-16 lg:px-8")}>
      <div className="mx-auto grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-12 md:max-w-xl md:grid-cols-6 md:gap-x-10 md:gap-y-14 lg:mx-0 lg:max-w-none lg:grid-cols-5">
        {data?.logos?.length > 0
          ? data?.logos?.map((item, index) => (
              <img
                key={index}
                alt={item?.name}
                src={item?.logo}
                width="158"
                height="48"
                className="col-span-2 col-start-2 max-h-12 w-full object-contain lg:col-span-1 lg:col-start-auto"
              />
            ))
          : [1, 2, 3, 4, 5].map(() => (
              <PlaceholderImage
                containerClasses="w-[100px] h-[70px] !flex-row gap-x-5 !rounded-xl !border-none !bg-transparent !opacity-60"
                iconClasses="!h-10 !w-10"
              />
            ))}
      </div>
    </section>
  );
}
